import { render, staticRenderFns } from "./PreserveContentSpacing.vue?vue&type=template&id=df0a1f48&scoped=true&"
import script from "./PreserveContentSpacing.vue?vue&type=script&lang=js&"
export * from "./PreserveContentSpacing.vue?vue&type=script&lang=js&"
import style0 from "./PreserveContentSpacing.vue?vue&type=style&index=0&id=df0a1f48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0a1f48",
  null
  
)

export default component.exports